import {ValueType} from '@/engine/types';
import {ArrayFilter} from '@/model/types';
import {DOMAIN_VALUE_PREFIX} from '@/model/types/constants';
import {getReferenceType} from './reference';
import {getDependenciesFromTemplate} from './template';

export const getDependenciesFromArrayFilters = (filters: ArrayFilter[]): string[] =>
  filters.flatMap(filter => {
    const dependencies = [filter.field.asQuery()];
    if (
      'value' in filter &&
      typeof filter.value === 'object' &&
      !Array.isArray(filter.value) &&
      '$ref' in filter.value &&
      !filter.value.$ref.startsWith(DOMAIN_VALUE_PREFIX)
    ) {
      dependencies.push(filter.value.$ref);
    }
    return dependencies;
  });

export const getValueDependencies = (value: ValueType): string[] => {
  if (typeof value === 'string' || typeof value === 'number') {
    return [];
  }

  if ('$template' in value) {
    if (typeof value.$template === 'string') {
      return getDependenciesFromTemplate(value.$template);
    } else {
      return Object.values(value.$template).flatMap(getDependenciesFromTemplate);
    }
  }

  if ('$generated' in value) {
    if ('$sum' in value.$generated) {
      if ('fields' in value.$generated.$sum) {
        return value.$generated.$sum.fields;
      }
      return [];
    }
    if ('$first' in value.$generated) {
      const {array, field, filters = []} = value.$generated.$first;
      return [`_${array}[count]`, field.asQuery(), ...getDependenciesFromArrayFilters(filters)];
    }
    return [];
  }

  if ('$query' in value) {
    return [value.$query];
  }

  if ('$ref' in value && getReferenceType(value.$ref) === 'state') {
    return [value.$ref];
  }

  return [];
};
